<template>
  <div id="case" class="case-container">
    <PublicModule title="案例中心">
      <a-row type="flex" justify="start" align="middle" class="case-wrapper">
        <a-col v-for="(item, index) in caseList" :key="index" :span="6">
          <div class="case-content">
            <div class="case-body">
              <div class="case-detail" @click.prevent="handleClick(item)">
                <img class="case-image" :src="item.logo" alt="">
                <div class="case-bar" />
                <p class="title">{{ item.name }}</p>
                <p class="info">{{ item.remark }}</p>
                <div class="btn-img" />
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </PublicModule>
  </div>
</template>

<script>
import PublicModule from '@/components/PublicModule.vue'

export default {
  name: 'Case',
  components: {
    PublicModule
  },
  data() {
    return {
      caseList: [
        {
          remark: '「你的城市，我的远方」---郑州',
          logo: require('../../assets/image/case1.png'),
          url: 'https://mp.weixin.qq.com/s/PD-BKT7p-7dBVRVDp8Jujg'
        },
        {
          remark: '「你的城市，我的远方」---遵义',
          logo: require('../../assets/image/case3.png'),
          url: 'https://mp.weixin.qq.com/s/5rXCvvL-KcspIPJ2aKyG6w'
        },
        {
          remark: '「你的城市，我的远方」---西安',
          logo: require('../../assets/image/case4.png'),
          url: 'https://mp.weixin.qq.com/s/nvFdArNORYWPxLLV5FFSqw'
        },
        {
          remark: '「你的城市，我的远方」---武汉',
          logo: require('../../assets/image/case5.png'),
          url: 'https://mp.weixin.qq.com/s/HsJC_-7Jrk93n_tHGHwZBg'
        },
        {
          remark: '「你的城市，我的远方」---鄂尔多斯',
          logo: require('../../assets/image/case6.png'),
          url: 'https://mp.weixin.qq.com/s/NOSOr1xFFdAY1kPCelJyoA'
        },
        {
          remark: '「你的城市，我的远方」---吉林',
          logo: require('../../assets/image/case7.png'),
          url: 'https://mp.weixin.qq.com/s/jq8D2sArvUjb1F5yj2wPLw'
        },
        {
          remark: '「你的城市，我的远方」---沈阳',
          logo: require('../../assets/image/case8.png'),
          url: 'https://mp.weixin.qq.com/s/PQ31Oj3NMxvskBH2ff7ZbA'
        },
        {
          remark: '「你的城市，我的远方」---合肥',
          logo: require('../../assets/image/case10.png'),
          url: 'https://mp.weixin.qq.com/s/0FBcUZdeH9H6SRrLmWEYsQ'
        },
        {
          remark: '「你的城市，我的远方」---苏州',
          logo: require('../../assets/image/case11.png'),
          url: 'https://mp.weixin.qq.com/s/fgTDSHCnLA6oguncXxnuJw'
        },
        {
          remark: '「你的城市，我的远方」---驻马店',
          logo: require('../../assets/image/case12.png'),
          url: 'https://mp.weixin.qq.com/s/hvHz9S12auBPmcey5f1ARA'
        },
        {
          remark: '「你的城市，我的远方」---长沙',
          logo: require('../../assets/image/case13.png'),
          url: 'https://mp.weixin.qq.com/s/Rnz1urGm8k4ZdZe9i0O9qQ'
        },
        {
          remark: '「你的城市，我的远方」---临夏',
          logo: require('../../assets/image/case14.png'),
          url: 'https://mp.weixin.qq.com/s/3mAyo5JOIEmCh005EY2FrQ'
        }
      ]
    }
  },
  methods: {
    handleClick(val) {
      window.open(val.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.case-container {
  width: 100%;
  padding: 0 120px;
  box-sizing: border-box;

  .case-wrapper {
    padding-top: 50px;

    .case-content {
      width: 100%;
      padding: 50px 20px;
      box-sizing: border-box;

      .case-body {
        padding-top: 60px;

        .case-detail {
          position: relative;
          padding: 167px 38px 40px;
          cursor: pointer;
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.16);
          text-align: left;
          font-family: PingFangSC, PingFangSC-Semibold;

          .case-image {
            position: absolute;
            top: -63px;
            left: 0;
            width: 88.89%;
            height: 230px;
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.16);
          }

          .case-bar {
            width: 68px;
            height: 8px;
            margin-top: 21px;
            margin-bottom: 12px;
            background-size: 68px 8px;
            background-image: url('../../assets/image/case.png');
            background-repeat: no-repeat;
          }

          .title {
            font-size: 24px;
            font-weight: 600;
            text-align: left;
            color: #2d2d2d;
            line-height: 33px;
            margin-bottom: 40px;
          }

          .info {
            height: 200px;
            font-size: 24px;
            font-weight: 400;
            line-height: 33px;
            color: #939393;
            margin-bottom: 40px;
            white-space: pre-wrap;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            line-clamp: 6;
            -webkit-box-orient: vertical;
          }

          .btn-img {
            width: 121px;
            height: 34px;
            background-size: 121px 34px;
            background-image: url('../../assets/image/default-btn.png');
            background-repeat: no-repeat;
          }

          &:hover {
            outline: 2.67px solid #0c27af;
            box-shadow: 5px 8px 20px 0px rgba(0, 40, 182, 0.35);

            .case-image {
              left: -2.67px;
            }

            .btn-img {
              background-image: url('../../assets/image/active-btn.png');
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .case-container {
    padding: 16px !important;
  }

  .case-wrapper .ant-col-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  .case-wrapper .case-content {
    padding: 12px 8px !important;
  }

  .case-detail {
    padding: 24px 16px !important;

    .case-image {
      position: static !important;
      width: 100% !important;
      height: auto !important;
      top: auto !important;
      left: auto !important;
      margin-bottom: 12px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    }

    .title {
      font-size: 18px !important;
      margin-bottom: 12px !important;
    }

    .info {
      height: auto !important;
      font-size: 14px !important;
      line-height: 1.6 !important;
      -webkit-line-clamp: unset !important;
      display: block !important;
      overflow: visible !important;
    }

    .btn-img {
      width: 100px !important;
      height: 30px !important;
    }
  }

  .case-wrapper a-col {
    width: 100% !important;
  }
}
</style>
